import officeApiExecAsync from './infrastructure/office-api-exec-async'
import officeApiGetAsync from './infrastructure/office-api-get-async'

export async function officeApiMailbox_UserIdentityTokenGetAsync(): Promise<string> {
  return officeApiGetAsync(
    '1.1',
    'Office.context.mailbox.getUserIdentityTokenAsync',
    () => new Promise<Office.AsyncResult<string>>((resolve) => Office.context.mailbox.getUserIdentityTokenAsync(resolve)),
    null,
  )
}

export async function officeApiMailbox_MasterCategoriesGetAsync(): Promise<Office.CategoryDetails[]> {
  return officeApiGetAsync(
    '1.8',
    'Office.context.mailbox.masterCategories.getAsync',
    () => new Promise<Office.AsyncResult<Office.CategoryDetails[]>>((resolve) => Office.context.mailbox.masterCategories.getAsync(resolve)),
    [],
  )
}

export async function officeApiMailbox_MasterCategoriesAddAsync(cats: Office.CategoryDetails[]): Promise<boolean> {
  return officeApiExecAsync(
    '1.8',
    'Office.context.mailbox.masterCategories.addAsync',
    () => new Promise<Office.AsyncResult<void>>((resolve) => Office.context.mailbox.masterCategories.addAsync(cats, resolve)),
  )
}

export async function officeApiMailbox_DisplayMessageFormAsync(id: string): Promise<boolean> {
  return officeApiExecAsync(
    '1.9',
    'Office.context.mailbox.displayMessageFormAsync',
    () => new Promise<Office.AsyncResult<void>>((resolve) => Office.context.mailbox.displayMessageFormAsync(id, resolve)),
  )
}

export async function officeApiMailbox_DisplayNewMessageFormAsync(params: any): Promise<boolean> {
  return officeApiExecAsync(
    '1.9',
    'Office.context.mailbox.displayNewMessageFormAsync',
    () => new Promise<Office.AsyncResult<void>>((resolve) => Office.context.mailbox.displayNewMessageFormAsync(params, resolve)),
  )
}

export async function officeApiMailbox_AddHandlerAsync(eventType: Office.EventType, handler: any): Promise<boolean> {
  return officeApiExecAsync(
    '1.5',
    'Office.context.mailbox.addHandlerAsync',
    () => new Promise<Office.AsyncResult<void>>((resolve) => Office.context.mailbox.addHandlerAsync(eventType, handler, resolve)),
  )
}

export async function officeApiMailbox_DisplayDialogAsync(redirect: string, options: Office.DialogOptions): Promise<Office.Dialog> {
  return officeApiGetAsync(
    '1.4',
    'Office.context.ui.displayDialogAsync',
    () => new Promise<Office.AsyncResult<Office.Dialog>>((resolve) => Office.context.ui.displayDialogAsync(redirect, options, resolve)),
  )
}

export async function officeApiMailbox_GetRestCallbackToken(): Promise<string> {
  return officeApiGetAsync(
    '1.5',
    'Office.context.mailbox.getCallbackTokenAsync',
    () => new Promise<Office.AsyncResult<string>>((resolve) => Office.context.mailbox.getCallbackTokenAsync({ isRest: true }, resolve)),
    null,
  )
}

export async function officeApiMailbox_GetEwsCallbackToken(): Promise<string> {
  return officeApiGetAsync(
    '1.3',
    'Office.context.mailbox.getCallbackTokenAsync',
    () => new Promise<Office.AsyncResult<string>>((resolve) => Office.context.mailbox.getCallbackTokenAsync(resolve, null)),
    null,
  )
}

export async function officeApiMailbox_MakeEwsRequestAsync(request: string): Promise<string> {
  return officeApiGetAsync(
    '1.1',
    'Office.context.mailbox.makeEwsRequestAsync',
    () => new Promise<Office.AsyncResult<string>>((resolve) => Office.context.mailbox.makeEwsRequestAsync(request, resolve)),
  )
}
